import { LDClient, LDFlags } from '~/providers';
import { FetchEnrollmentOptionsParams } from '~/services/fetch-enrollment-option';
import { EnrollmentDataSource } from '~/typings/context';

// higher == more preferential
/* eslint-disable camelcase */
const order: Record<EnrollmentDataSource, number> = {
  utility_connect: 4,
  partner_provided: 3,
  bill_capture: 2,
  none: 1,
};
/* eslint-disable camelcase */

export const getEnrollmentOptions = (context: FetchEnrollmentOptionsParams) => {
  const { preference, limit } = context;
  const enrollmentOptions: EnrollmentDataSource[] = LDClient.variation(
    LDFlags.fetchUtilityEnrollmentOptions,
  ).sort((a, b) => (order[b] || 0) - (order[a] || 0));

  if (preference && enrollmentOptions.includes(preference)) {
    return { enrollmentOptions: [preference] };
  } else if (limit) {
    return { enrollmentOptions: enrollmentOptions.slice(0, limit) };
  } else if (
    !(
      enrollmentOptions.includes('partner_provided') &&
      LDClient.variation(LDFlags.showFallbackButton)
    )
  ) {
    /**
     * The decision to include partner_provided is based on the following truth table:
     * |-----|-----|------------------------------|
     * | EP  | LD  |            Result            |
     * |-----|-----|------------------------------|
     * |--T--|--T--|---enable partner_provided----|
     * |--T--|--F--|---disable partner_provided---|
     * |--F--|--T--|---disable partner_provided---|
     * |--F--|--F--|---disable partner_provided---|
     * |-----|-----|------------------------------|
     *
     * */

    return {
      enrollmentOptions: enrollmentOptions.filter(option => option !== 'partner_provided'),
    };
  }
  return { enrollmentOptions };
};
